import { render, staticRenderFns } from "./DynamicIcon.vue?vue&type=template&id=00b6c6d1&scoped=true&"
import script from "./DynamicIcon.vue?vue&type=script&lang=js&"
export * from "./DynamicIcon.vue?vue&type=script&lang=js&"
import style0 from "./DynamicIcon.vue?vue&type=style&index=0&id=00b6c6d1&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "00b6c6d1",
  null
  
)

export default component.exports